import { cn } from '@/lib/utils'
import { Label } from '@/ui/Shadcn/label'
import { Icon } from '@/ui/components'

interface InputFakeProps {
  label?: string
  value?: string | number | null
  placeholder?: string
  props?: React.ComponentProps<'button'>
  className?: string
  active?: boolean
  onBlur?: () => void
  onFocus?: () => void
  disabled?: boolean
}

const InputFake = ({
  value,
  label,
  placeholder,
  className,
  disabled = false,
  active = false,
  onBlur,
  onFocus,
  ...props
}: InputFakeProps) => (
  <button
    disabled={disabled}
    onBlur={onBlur}
    onFocus={onFocus}
    className={cn(
      'pr-xl relative flex flex-col bg-neutral-200 text-left text-neutral-600 disabled:opacity-50',
      className
    )}
    {...props}
  >
    {label && (
      <Label className="top-md left-md absolute text-neutral-600">
        {label}
      </Label>
    )}

    <span
      className={cn(
        'px-md pb-xs pt-lg textstyle-md-regular block h-auto',
        !value && 'text-neutral-400!'
      )}
    >
      {value || placeholder}
    </span>

    <Icon
      icon="material-symbols:keyboard-arrow-down"
      className={cn(
        'right-md absolute top-1/2 size-5 -translate-y-1/2',
        active && 'rotate-180'
      )}
    />
  </button>
)

InputFake.displayName = 'InputFake'

export default InputFake
